// Exact color values converted from OKLCH CSS variables in theme.css
// Light theme (default) and dark theme

export const LightColors = {
  // Surfaces
  paper:   '#F9F8F6',
  paper2:  '#F3F2EF',
  paper3:  '#EDECEA',
  card:    '#FFFFFF',

  // Ink (text)
  ink:     '#1E2635',
  ink2:    '#3B4560',
  ink3:    '#6B748A',
  ink4:    '#9EA6B8',

  // Lines
  line:        '#E4E6EF',
  lineStrong:  '#C8CBDA',

  // Accent (primary blue)
  accent:      '#3B5BD5',
  accentInk:   '#2440A8',
  accentSoft:  '#EEF1FC',
  accentLine:  '#B3C0F0',

  // Info
  info:      '#3B6FD5',
  infoSoft:  '#EEF2FC',
  infoLine:  '#B3C4F0',

  // Success
  success:      '#2D8A5F',
  successSoft:  '#EBF6F1',
  successLine:  '#A3D5BE',

  // Warn
  warn:      '#B87D0A',
  warnSoft:  '#FDF4E3',
  warnLine:  '#E8C97A',

  // Danger
  danger:      '#C94444',
  dangerSoft:  '#FCEAEA',
  dangerLine:  '#EDA8A8',

  // Neutral
  neutral:      '#4A8A8A',
  neutralSoft:  '#EBF4F4',
  neutralLine:  '#A8D0D0',

  // Semantic aliases
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',
};

export const DarkColors = {
  // Surfaces — neutral charcoal (not pure black), with clear page↔card contrast
  paper:   '#1A1A1D',
  paper2:  '#222227',
  paper3:  '#2A2A30',
  card:    '#242429',

  // Ink (neutral greys)
  ink:     '#F4F4F5',
  ink2:    '#C9C9CC',
  ink3:    '#9A9A9E',
  ink4:    '#6A6A6E',

  // Lines
  line:        '#34343A',
  lineStrong:  '#434349',

  // Accent (clean blue for actions; soft is a raised charcoal tint)
  accent:      '#6E8CF0',
  accentInk:   '#A9BEF6',
  accentSoft:  '#23293A',
  accentLine:  '#3A496B',

  // Info
  info:      '#6E92F0',
  infoSoft:  '#222a3a',
  infoLine:  '#3A4A6B',

  // Success
  success:      '#54C796',
  successSoft:  '#1B2B22',
  successLine:  '#315340',

  // Warn
  warn:      '#E6B24E',
  warnSoft:  '#2B2415',
  warnLine:  '#665226',

  // Danger
  danger:      '#E97676',
  dangerSoft:  '#2E1E1E',
  dangerLine:  '#6A3838',

  // Neutral
  neutral:      '#8A8A8E',
  neutralSoft:  '#26262B',
  neutralLine:  '#3A3A40',

  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',
};

export type ColorScheme = typeof LightColors;
